'use client';

import Box from '@mui/material/Box';
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from '@fortawesome/react-fontawesome';
import { Color } from '@/theme/color';
import { getColorContrast } from '@/utils/color';

interface CircleProps {
  $color?: Color;
  $padding?: string;
  $isElevation?: boolean;
  children: React.ReactNode;
}
export const Circle = ({
  $color,
  $padding,
  $isElevation,
  children,
}: CircleProps) => (
  <Box
    sx={{
      position: 'relative',
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: $color,
      color: getColorContrast($color || '#ff0000'),
      borderRadius: '99999px',
      p: $padding,
      aspectRatio: '1/1',
      width: 'min-content',
      ...($isElevation && {
        boxShadow:
          '0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)',
      }),
    }}
  >
    {children}
  </Box>
);

interface StyledFontAwesomeIconProps extends FontAwesomeIconProps {
  $fontSize?: number;
  $isFill?: boolean;
  $isHidden?: boolean;
}
export const StyledFontAwesomeIcon = ({
  $fontSize,
  $isFill,
  $isHidden,
  style: incomingStyle,
  ...props
}: StyledFontAwesomeIconProps) => (
  <FontAwesomeIcon
    {...props}
    style={{
      ...incomingStyle,
      ...($fontSize && { fontSize: `${$fontSize}px` }),
      ...($isFill && {
        position: 'absolute' as const,
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
      }),
      ...($isHidden && { visibility: 'hidden' as const }),
    }}
  />
);
